import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              关于7788电影网
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              追剧这件事，我们是认真的
            </p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-10 space-y-5 md:space-y-6">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              <strong className="text-foreground-900">{aboutData.title}</strong>
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutData.description1}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutData.description2}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutData.description3}
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-background-200/70">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-primary-600">10万+</div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">剧集资源</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-primary-600">2019</div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">成立年份</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-primary-600">500万+</div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">日活跃用户</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-primary-600">99.9%</div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">可用性保障</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}